<template>
  <div>
    <fin-dropdown v-if="items && items.length > 0"
                  :dropdown-height="'50vh'"
                  :hide-all-selection="hideAllSelection || singleSelect"
                  :items="items"
                  :label="label"
                  :single-select="singleSelect"
                  :value="value"
                  show-selection-badge
                  @input="val => selectedItemsChanged(val)">
      <template #default="{item}">
        {{ item.name }}
      </template>
    </fin-dropdown>
    <p v-else>Keine Daten verfügbar</p>

    <v-btn icon style="float: right;" v-if="showRemoveIcon" @click="$emit('delete')">
      <v-icon>icon-delete</v-icon>
    </v-btn>

    <div v-if="value.length > 0"
         style="min-height: 32px;"
         class="mb-3">
      <div class="mr-2" style="font-weight: bold; display: inline-block;">
        {{ activeFilterPrependLabel }}
        <v-btn v-if="selectedItems.length > 0"
               icon
               x-small
               @click="removeAllActiveFilters">
          <v-icon>icon-delete</v-icon>
        </v-btn>
      </div>

      <fin-tag v-for="filter in selectedItems"
               :key="filter.id" class="mr-2"
               style="display: inline-block;line-height: 30px">
        {{ filter.name }}
        <v-btn icon
               x-small
               @click="removeFilter(filter.id)">
          <v-icon>icon-close-small</v-icon>
        </v-btn>
      </fin-tag>
    </div>
  </div>
</template>

<script>
import FinDropdown from "@/components/common/Dropdown"

export default {
  name: 'FinScreenerDropdownSelector',
  components: {FinDropdown},
  props: {
    label: {
      type: String
    },
    value: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array
    },
    hideAllSelection: {
      type: Boolean,
      default: false
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    activeFilterPrependLabel: {
      type: String,
      default: 'Aktive Filter:'
    },
    showRemoveIcon: {
      type: Boolean,
      default: true
    },
    removeAllActiveFiltersConfirmTitle: {
      type: String,
      default: 'Filter löschen'
    },
    removeAllActiveFiltersConfirmText: {
      type: String,
      default: 'Möchtest du alle aktiven Filter zurücksetzen?'
    },
    checkAttribute: {
      type: String,
      default: 'id'
    }
  },
  data() {
    return {
      selectedItems: this.value
    }
  },
  methods: {
    selectedItemsChanged(selectedItems) {
      this.selectedItems = selectedItems
      this.$emit('input', this.selectedItems)
    },
    removeFilter(id) {
      if (id) {
        this.selectedItemsChanged(this.selectedItems.filter(c => c.id !== id))
      }
    },
    removeAllActiveFilters() {
      this.$confirm({
        title: this.removeAllActiveFiltersConfirmTitle,
        text: this.removeAllActiveFiltersConfirmText,
        dialogWidth: 300,
        confirmBtn: 'Ja'
      })
        .then(() => {
          this.selectedItemsChanged([])
        }).catch(() => {
      })
    },
  },
  watch: {
    value(newVal) {
      this.selectedItems = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .dropdown-btn {
  margin-right: 0 !important;
}
</style>
